import { Sparkles, Check } from "lucide-react";
import { buildWhatsAppLink } from "@/data/lakaData";

const includes = [
  "Punta de diamante",
  "Peeling ultrasónico",
  "Máscara LED",
];

const Featured = () => {
  const goTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  const wa = buildWhatsAppLink(
    "Hola LAKA, quiero reservar el Pack Piel Radiante (45€ / 45 min).",
  );

  return (
    <section
      data-testid="featured-section"
      className="py-24 md:py-32"
      style={{ background: "#1A1A1A", color: "#FBF6F2" }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <span className="laka-eyebrow">Campaña destacada</span>
            <h2 className="mt-5 font-serif-laka text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05]">
              Pack <span className="italic text-[#D6B36A]">Piel Radiante</span>
            </h2>
            <p className="mt-4 text-lg md:text-xl text-[#FBF6F2]/80 font-light">
              Limpieza, renovación y luminosidad en una sola sesión.
            </p>
            <p className="mt-6 text-[#FBF6F2]/70 max-w-xl leading-relaxed font-light">
              Una experiencia facial completa para limpiar, renovar e iluminar la
              piel con un acabado fresco y cuidado.
            </p>

            <ul className="mt-8 space-y-3">
              {includes.map((it) => (
                <li key={it} className="flex items-center gap-3 text-sm">
                  <Check
                    className="w-4 h-4 text-[#D6B36A]"
                    strokeWidth={1.6}
                  />
                  <span className="text-[#FBF6F2]/90">{it}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-wrap items-center gap-5">
              <div>
                <div className="text-[0.62rem] tracking-[0.3em] uppercase text-[#D6B36A]">
                  Desde
                </div>
                <div className="font-serif-laka text-5xl text-[#FBF6F2] mt-1">
                  45€
                  <span className="text-lg text-[#FBF6F2]/60 ml-2 font-sans-laka">
                    / 45 min
                  </span>
                </div>
              </div>
              <a
                data-testid="featured-book-btn"
                href={wa}
                target="_blank"
                rel="noreferrer"
                className="laka-btn-primary laka-btn-gold"
              >
                Reservar por WhatsApp
                <Sparkles className="w-4 h-4" strokeWidth={1.4} />
              </a>
              <button
                data-testid="featured-form-btn"
                onClick={() => goTo("contacto")}
                className="laka-btn-ghost"
                style={{ color: "#FBF6F2", borderColor: "#FBF6F2" }}
              >
                Solicitar cita
              </button>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2 relative">
            <div className="relative">
              <div
                className="absolute -inset-4 border border-[#D6B36A]/40"
                aria-hidden="true"
              />
              <img
                src="https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Pack Piel Radiante"
                className="relative w-full h-[420px] md:h-[560px] object-cover"
                loading="lazy"
              />
              <div className="absolute top-6 right-6 bg-[#D6B36A] text-[#1A1A1A] px-4 py-2 text-[0.65rem] tracking-[0.3em] uppercase font-medium">
                Bestseller
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Featured;
